import React from 'react';

import Validation from 'modules/react-validation';

import TextField from 'sharedreact/components/TextField';
import { translate } from 'sharedreact/utils/LanguageSupport';
import Dialog from 'sharedreact/components/Dialog';

type Props = {
  language: string,
  show: boolean,
  isForTestEnv: boolean,

  onClose: () => void,
  onLogin: (userName: string, password: string) => void,
};

type State = {
  userName: string,
  password: string
};

class EskoIDSignInDialog extends React.Component<Props, State> {
  constructor (props: Props) {
    super(props);

    this.state = {
      userName: '',
      password: ''
    };
  
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
  }


  handleClose () {
    const { onClose } = this.props;
    onClose();
  }

  handleSubmit (event?: React.MouseEvent<HTMLButtonElement>): void {
    const { onLogin } = this.props;

    event?.preventDefault();

    onLogin(this.state.userName, this.state.password);
  }

  handleChangeValue (name: string, value: string): void {
    switch (name) {
      case 'userName': {
        this.setState({userName: value});
        break;
      }
      case 'password': {
        this.setState({password: value});
        break;
      }
    }
  }

  override render (): React.ReactNode {
    const { show, isForTestEnv, language } = this.props;

    return (
      <Dialog
        id='ae_dialog_eskoid_signin'
        show={show}
        language={language}
        title={translate('launcher.eskoid.dialog.signin') + (isForTestEnv ? ' - R&D' : '')}
        onClose={this.handleClose}
        onConfirm={this.handleSubmit}
        disableConfirm={this.state.userName === '' || this.state.password === ''}
        primaryButton='confirm'
        closeText={translate('launcher.eskoid.button.cancel')}
        confirmText={translate('launcher.eskoid.button.signin')}
      >
        <Validation.components.Form className='webappslauncher-eskoid-signin'>
          <div className='webappslauncher-eskoid-signin-usernamepassword'>
            <TextField id='ae_input_eskoid_signin_username'
              name='userName'
              label={translate('launcher.eskoid.username')}
              value={this.state.userName}
              onChangeValue={this.handleChangeValue}
              autoComplete='username'
              selected
            />
            <TextField id='ae_input_eskoid_signin_password'
              name='password'
              type='password'
              label={translate('launcher.eskoid.password')}
              value={this.state.password}
              onChangeValue={this.handleChangeValue}
              autoComplete='current-password'
            />
            <div className='webappslauncher-eskoid-createaccount'>
              <a id='ae_button_eskid_createaccount'
                href='https://signin.esko.com/Customer/RegisterCustomer' target='_blank'>{translate('launcher.eskoid.createaccount')}</a>
            </div>
            <div className='webappslauncher-eskoid-forgotpassword'>
              <a id='ae_button_eskid_forgotpassword'
                href='https://signin.esko.com/Customer/ForgotPassword' target='_blank'>{translate('launcher.eskoid.forgotpassword')}</a>
            </div>
          </div>
        </Validation.components.Form>
      </Dialog>
    );
  }
}

export default EskoIDSignInDialog;
